import React, { useCallback, useState } from 'react';
import { TextLink, IconButton } from '@oneaudi/unified-web-components';
import { PriceBreakdownModalContent } from './PriceBreakdownModalContent';
import ReactDOM from 'react-dom';
import { useServicesContext } from '../../../../../context';
import { usePriceConfiguration } from '../../../../../hooks';
import { FootnoteReferenceContextProvider } from '../../../../../components';
import { useI18n } from '@oneaudi/i18n-context';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
export const PriceBreakdownCta = ({ vehicle, variant = 'text', }) => {
    const configuration = useServicesContext().getConfiguration();
    const layerManager = useServicesContext().getAdditionalService('gfa:layer-manager');
    const ariaLabelCta = useI18n({
        id: 'stockcars.prices.pricebreakdown.cta.arialabel',
        defaultMessage: '',
    });
    const textLinkLabel = useI18n({
        id: 'stockcars.prices.pricebreakdown.textlink.label',
        defaultMessage: '',
    });
    const { priceConfiguration } = configuration;
    if (!priceConfiguration || priceConfiguration.length < 1)
        return null;
    const hasMatchingRelevancy = priceConfiguration === null || priceConfiguration === void 0 ? void 0 : priceConfiguration.some((priceItem) => {
        var _a, _b, _c;
        return ((_a = priceItem === null || priceItem === void 0 ? void 0 : priceItem.fields) === null || _a === void 0 ? void 0 : _a.availability) === (vehicle === null || vehicle === void 0 ? void 0 : vehicle.availableFromCode) &&
            ((_b = priceItem === null || priceItem === void 0 ? void 0 : priceItem.fields) === null || _b === void 0 ? void 0 : _b.businessModel) === ((_c = vehicle === null || vehicle === void 0 ? void 0 : vehicle.businessModel) === null || _c === void 0 ? void 0 : _c.code);
    });
    if (!hasMatchingRelevancy) {
        return null;
    }
    const priceGroups = usePriceConfiguration(vehicle, priceConfiguration);
    const [layerNode, setLayerNode] = useState();
    const layerRef = useCallback((node) => {
        setLayerNode(node);
    }, [setLayerNode]);
    const footnoteReferenceServiceScopeManager = useServicesContext().getAdditionalService('audi-footnote-reference-service');
    const scopedFootnoteReferenceService = footnoteReferenceServiceScopeManager.getCustomScopeRefService('priceBreakDownLayer');
    const openFocusLayer = () => {
        layerManager === null || layerManager === void 0 ? void 0 : layerManager.openFocusLayer(() => (React.createElement(React.Fragment, null,
            React.createElement("section", { ref: layerRef }))), {
            withFefa: true,
        }, {
            size: "A",
            userCloseable: true,
            onClose: () => { },
        });
    };
    return (React.createElement(React.Fragment, null,
        variant === 'text' && (React.createElement(TextLink, { "data-testid": "pricebreakdown-textlink", onClick: openFocusLayer, size: "sm", "aria-label": ariaLabelCta, variant: "standalone" }, textLinkLabel)),
        variant === 'icon' && (React.createElement(IconButton, { icon: "info-circle", id: "icon-button-id", onClick: openFocusLayer, size: dynamicStylingHelper('md', 'xs'), type: "button", "data-testid": "pricebreakdown-icon-button", "aria-label": ariaLabelCta, variant: "tertiary" })),
        layerNode &&
            ReactDOM.createPortal(React.createElement(FootnoteReferenceContextProvider, { footnoteReferenceServiceScopeManager: footnoteReferenceServiceScopeManager, customScope: scopedFootnoteReferenceService.getConsumerId() },
                React.createElement(PriceBreakdownModalContent, { vehicle: vehicle, priceGroups: priceGroups })), layerNode)));
};
